import React from 'react';
import { Box, Grid } from '@mui/material';
import Shimmer from 'ui-components/Shimmer';

// Placeholder shaped like ReportCard in Reports.js. Numbers come from that file.
const CARD_BORDER = '#EAECF0';

// Four rows at lg - the cards are narrow, so fewer leaves the viewport half empty.
const CARD_COUNT = 12;

const cardSx = {
  bgcolor: '#fff',
  border: `1px solid ${CARD_BORDER}`,
  borderRadius: '12px',
  p: 2,
};

// The startup detail Reports tab renders the same card, so it reuses this with
// its own count - one startup has far fewer reports than the /reports page.
const ReportsSkeleton = ({ count = CARD_COUNT }) => (
  <Grid container spacing={2}>
    {Array.from({ length: count }).map((_, i) => (
      <Grid item xs={12} sm={6} lg={4} key={i}>
        <Box sx={{ ...cardSx, height: '100%', display: 'flex', flexDirection: 'column', gap: 1.25 }}>
          {/* 36px avatar + name */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
            <Shimmer width={36} height={36} radius={8} />
            <Shimmer width="55%" height={13} radius={4} />
          </Box>

          {/* Report title */}
          <Shimmer width="70%" height={14} radius={4} />

          {/* Description, clamped to two lines */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
            <Shimmer width="100%" height={10} radius={4} />
            <Shimmer width="85%" height={10} radius={4} />
          </Box>

          {/* Date, document count, file type */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 'auto', pt: 0.5 }}>
            <Shimmer width={84} height={11} radius={4} />
            <Shimmer width={92} height={11} radius={4} />
            <Shimmer width={30} height={11} radius={4} sx={{ ml: 'auto' }} />
          </Box>
        </Box>
      </Grid>
    ))}
  </Grid>
);

export default ReportsSkeleton;
